export async function registerGuestPwa(serviceWorkerUrl, scope) {
  if (!("serviceWorker" in navigator)) return null

  const workerUrl = new URL(serviceWorkerUrl, window.location.origin)
  const scopeUrl = new URL(scope, window.location.origin)
  if (workerUrl.origin !== window.location.origin || scopeUrl.origin !== window.location.origin) return null

  const response = await fetch(workerUrl, {
    method: "HEAD",
    credentials: "same-origin",
    cache: "no-store"
  })
  if (!response.ok || !response.headers.get("Content-Type")?.includes("javascript")) return null

  return navigator.serviceWorker.register(workerUrl.href, { scope: scopeUrl.pathname })
}
